import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {canAccessTeamChat} from 'app/navigation/nahaus.navigation';
import {AuthService} from '@shared/services/auth.service';
import {filter, map, take} from 'rxjs/operators';

/**
 * The team chat is an ENTERPRISE feature available on beta only.
 * Everyone else lands on the ENTERPRISE upgrade page (431).
 */
export const canAccessTeamChatGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (canAccessTeamChat(authService.tier)) {
        return true;
    }

    // Wait until the auth claims are processed — tier$ starts as undefined and
    // becomes a tier or null once the token has been decoded
    return authService.tier$.pipe(
        filter((tier) => tier !== undefined),
        take(1),
        map((tier) => canAccessTeamChat(tier)
            ? true
            : router.createUrlTree(['fehler', '431']))
    );
};
